import React, { useState, useEffect, useContext, use } from 'react'
import styled from 'styled-components'
const CompanyContainer = styled.div``

const EmptyContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
import { getCookie } from 'helper/cookie'
import {
  getDataCompanyV2,
  getBusinessListV2,
  getTreeCompany,
  getTreeCompanyV2,
  getDataCompanyByID,
} from 'api/Admin/company'
import { Button, Table, Input, Space, Checkbox, Divider } from 'antd'
import Tree from '../Tree/Company/Tree'
import { PlusOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons'

import iconEmpty from 'icons/createproject/supportneed.svg'

import DrawerCompany from 'components/Management/components/Drawer/company/drawercompany'
import DrawerOperation from 'components/Management/components/Drawer/company/drawerOperation'
import DrawerSubOperation from 'components/Management/components/Drawer/company/drawerSubOperation'
import FilterSearchTree from './FilterSearchTree'

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}

const tableFieldToApiField = {
  Company: 'code',
  LocalName: 'name',
  EnglishName: 'name_en',
  ShortName: 'short_name',
  ABBRName: 'abbr_name',
  Status: 'status',
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import lang from 'lang/en'
const Company = (props) => {
  const { infoUser, openDefaultTree } = props

  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)

  //company drawer
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')

  //operation drawer
  const [visible2, setVisible2] = useState(false)
  const [stateDrawer2, setStateDrawer2] = useState('')
  const [titleDrawer2, setTitleDrawer2] = useState('')
  const [idOptionOperation, setIdOptionOperation] = useState()

  //suboperation drawer
  const [visible3, setVisible3] = useState(false)
  const [stateDrawer3, setStateDrawer3] = useState('')
  const [titleDrawer3, setTitleDrawer3] = useState('')
  const [parent_ID, setParent_ID] = useState('')

  //datacompany
  const [dataCompany, setDataCompany] = useState(initalState.data)
  const [dataEditCompany, setDataEditCompany] = useState(initalState.data)

  //datatree
  const [treeCompany, setTreeCompany] = useState(initalState.data)
  const [level, setLevel] = useState(1)
  const [level_ID, setLevel_ID] = useState(0)
  const [checkByID, setCheckByID] = useState()
  const [companyID, setCompanyID] = useState()

  //table
  const [checkChangeTable, setCheckChangeTable] = useState(0)
  const [checkRenderDelete, setCheckRenderDelete] = useState(false)

  //search
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [businessQuery, setBusinessQuery] = useState({
    page: 1,
    per_page: initalState.pagination.pageSize,
    search_by: '',
    search: '',
    order_by: '',
    order: '',
  })

  const [pagination, setPagination] = useState(initalState.pagination)

  //checkrole
  const { adminPermission } = useContext(CounterContext)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })
  // ใช้สำหรับเก็บรายการที่ถูกเลือกใน filter bu
  const [filteredCompanies, setFilteredCompanies] = useState([])
  const [filterDataCompany, setFilterDataCompany] = useState([])
  const [filteredTreeCompany, setFilteredTreeCompany] = useState([])
  const [companyOption, setCompanyOption] = useState(initalState.data)

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 11) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // useEffect for filteredCompanies
  useEffect(() => {
    if (filteredCompanies.length > 0) {
      const filteredTree = {
        ...treeCompany[0], // คงข้อมูล key, title, level, level_id เดิม
        children: treeCompany[0].children?.filter((item) =>
          filteredCompanies.includes(item.id),
        ),
      }

      setFilteredTreeCompany(Array(filteredTree))

      const dataCompanyFiltered = dataCompany.filter((item) =>
        filteredCompanies.includes(item.id),
      )

      setFilterDataCompany(dataCompanyFiltered)
    } else {
      setFilteredTreeCompany(treeCompany)
      setFilterDataCompany(dataCompany)
    }
  }, [filteredCompanies, treeCompany, dataCompany])

  //tree
  const getResultTreeCompany = async () => {
    // await getTreeCompany({
    //   token: token,
    //   language: language,
    // })
    //   .then(async (response) => {
    //     const { status, data, error } = response

    //     if (error) {
    //       setTreeCompany([])
    //       setIsLoading(false)
    //       return true
    //     }

    //     if (status === 200) {
    //       setTreeCompany(data)
    //       setIsLoading(false)
    //     } else {
    //       setTreeCompany([])
    //       setIsLoading(false)
    //       return true
    //     }
    //   })
    //   .catch((error) => {
    //     setTreeCompany([])
    //     setIsLoading(false)
    //     console.error(error)
    //   })
    await getTreeCompanyV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setTreeCompany([])
          setIsLoading(false)
          return true
        }

        if (status === 200) {
          setTreeCompany(data.result)
          if (data.result?.[0]?.children) {
            setCompanyOption(data.result[0].children)
          }
          setIsLoading(false)
        } else {
          setTreeCompany([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setTreeCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  //data company
  const getResultDataCompany = async () => {
    if (level === 1) {
      await getBusinessListV2({
        token: token,
        page: businessQuery.page,
        per_page: businessQuery.per_page,
        search_by: businessQuery.search_by,
        search: businessQuery.search,
        order_by: businessQuery.order_by,
        order: businessQuery.order,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (error) {
            setDataCompany([])
            setPagination(false)
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            const result = data?.result || {}
            const resultData = result?.data || []
            setDataCompany(resultData)
            setPagination({
              ...initalState.pagination,
              pageSize: businessQuery.per_page,
              current: result?.current_page || 1,
              total: result?.total || 0,
            })
            setIsLoading(false)
          } else {
            setDataCompany([])
            setPagination(false)
            setIsLoading(false)
            return true
          }
        })
        .catch((error) => {
          setDataCompany([])
          setPagination(false)
          setIsLoading(false)
          console.error(error)
        })
      return
    }

    await getDataCompanyV2({
      token: token,
      level: level,
      level_id: level_ID,
      parent_id: parent_ID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCompany(data.result)
          if (data.result.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }
          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResultDataCompanyDelete = async (levelid) => {
    await getResultDataCompany()
  }

  const getResultDataCompanyByID = async () => {
    await getDataCompanyByID({
      token: token,
      level_id: companyID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          let a = []
          a.push(data)
          setDataCompany(a)
          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const onClose = (value) => {
    setVisible(false)
  }

  useEffect(() => {
    if (token) {
      getResultTreeCompany()
      if (checkChangeTable === 9998) {
        setCheckChangeTable(0)
      }
    }
  }, [token, checkChangeTable])

  useEffect(() => {
    if (token) {
      getResultDataCompany()
    }
  }, [token, checkChangeTable, level, level_ID, parent_ID, businessQuery])

  const getColumnSearchProps = (dataIndex, isServerMode = false, state) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      if (state == 'delete') {
        handleReset()
      }
      const defaultValue =
        isServerMode &&
        businessQuery.search_by === tableFieldToApiField[dataIndex] &&
        businessQuery.search
          ? businessQuery.search
          : selectedKeys[0]
      return (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={defaultValue}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() =>
              handleSearch(
                selectedKeys[0] === undefined ? [defaultValue] : selectedKeys,
                confirm,
                dataIndex,
                isServerMode,
              )
            }
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              className="mini-search-btn-admin"
              onClick={() =>
                handleSearch(
                  selectedKeys[0] === undefined ? [defaultValue] : selectedKeys,
                  confirm,
                  dataIndex,
                  isServerMode,
                )
              }
            >
              <SearchOutlined className="icon" />
              {word['Search']}
            </Button>
            <Button
              type="primary"
              className="mini-search-btn-admin-reset"
              onClick={() => handleReset(clearFilters, isServerMode)}
            >
              {word['Reset']}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    ...(isServerMode
      ? {
          filtered:
            businessQuery.search_by === tableFieldToApiField[dataIndex] &&
            !!businessQuery.search,
        }
      : {
          onFilter: (value, record) =>
            record[dataIndex]
              ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
              : '',
        }),

    render: (text) => (searchedColumn === dataIndex ? text : text),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex, isServerMode = false) => {
    confirm()
    if (isServerMode) {
      const searchValue = selectedKeys[0] || ''
      setBusinessQuery((prevState) => ({
        ...prevState,
        page: 1,
        search_by: searchValue ? tableFieldToApiField[dataIndex] : '',
        search: searchValue,
      }))
      return
    }
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters, isServerMode = false) => {
    if (clearFilters) {
      clearFilters()
    }
    if (isServerMode) {
      setBusinessQuery((prevState) => ({
        ...prevState,
        page: 1,
        search_by: '',
        search: '',
      }))
      return
    }
    setSearchText('')
  }

  const dataSource = filterDataCompany.map((item) => {
    const shortName = item.short_name || item.shot_name || ''
    if (item.abbr_name == undefined) {
      item.abbr_name = ''
    }
    return {
      key: item.code,
      Company: item.code,
      LocalName: item.name_th,
      EnglishName: item.name_en,
      ABBRName: item.abbr_name,
      ShortName: shortName,
      Status: item.status || '',
      dataAll: item,
    }
  })

  const TableTitle = (value) => {
    return <h5>{value}</h5>
  }

  const columns = [
    {
      title: TableTitle(word['Business']),
      dataIndex: 'Company',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.Company
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('Company', true),
      ellipsis: true,
      width: 130,
    },

    {
      title: TableTitle('Local business name'),
      dataIndex: 'LocalName',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.LocalName
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('LocalName', true),
      ellipsis: true,
    },
    {
      title: TableTitle(word['English_business_name']),
      dataIndex: 'EnglishName',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.EnglishName
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('EnglishName', true),
      ellipsis: true,
      width: 210,
    },
    {
      title: TableTitle(word['Short_name']),
      dataIndex: 'ShortName',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.ShortName
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('ShortName', true),
      ellipsis: true,
    },
    {
      title: TableTitle(word['ABBR_name']),
      dataIndex: 'ABBRName',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.ABBRName
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('ABBRName', true),
      ellipsis: true,
    },
    {
      title: TableTitle('Status'),
      dataIndex: 'Status',
      sorter: true,
      sortOrder:
        businessQuery.order_by === tableFieldToApiField.Status
          ? businessQuery.order === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      ...getColumnSearchProps('Status', true),
      ellipsis: true,
      width: 140,
    },
  ]

  const dataSource2 = dataCompany.map((item) => ({
    key: item.code,
    Company: item.company_code,
    Operation: item.code,
    LocalName: item.name_th,
    EnglishName: item.name_en,
    Status: item.status || '',
    dataAll: item,
  }))

  const columns2 = [
    {
      title: TableTitle(word['Business']),
      dataIndex: 'Company',
      ellipsis: true,
      width: 130,
    },
    {
      title: TableTitle(word['Operation']),
      dataIndex: 'Operation',
      sorter: (a, b) => a.Operation.localeCompare(b.Operation),
      ...getColumnSearchProps('Operation'),
      ellipsis: true,
      width: 160,
    },

    {
      title: TableTitle(word['Local_operation_name']),
      dataIndex: 'LocalName',
      sorter: (a, b) => a.LocalName.localeCompare(b.LocalName),
      ...getColumnSearchProps('LocalName'),
      ellipsis: true,
    },
    {
      title: TableTitle(word['English_operation_name']),
      dataIndex: 'EnglishName',
      sorter: (a, b) => a.EnglishName.localeCompare(b.EnglishName),
      ...getColumnSearchProps('EnglishName'),
      ellipsis: true,
    },
    {
      title: TableTitle('Status'),
      dataIndex: 'Status',
      sorter: (a, b) => a.Status.localeCompare(b.Status),
      ...getColumnSearchProps('Status'),
      ellipsis: true,
      width: 140,
    },
  ]

  const dataSource3 = dataCompany.map((item) => {
    if (item.name_en == undefined) {
      item.name_en = ''
    }

    return {
      key: item.code,
      Company: item.company_code,
      Operation: item.operation_code,
      SubOperation: item.code,
      LocalName: item.name_th,
      EnglishName: item.name_en,
      Status: item.status || '',
      dataAll: item,
    }
  })

  const columns3 = [
    {
      title: TableTitle('Business'),
      dataIndex: 'Company',
      ellipsis: true,
      width: 130,
    },
    {
      title: TableTitle(word['Operation']),
      dataIndex: 'Operation',
      ellipsis: true,
      width: 130,
    },
    {
      title: TableTitle(word['Sub_operation']),
      dataIndex: 'SubOperation',
      sorter: (a, b) => a.SubOperation.localeCompare(b.SubOperation),
      ...getColumnSearchProps('SubOperation'),
      ellipsis: true,
      width: 160,
    },

    {
      title: TableTitle(word['Local_sub_operation_name']),
      dataIndex: 'LocalName',
      sorter: (a, b) => a.LocalName.localeCompare(b.LocalName),
      ...getColumnSearchProps('LocalName'),
      ellipsis: true,
    },
    {
      title: TableTitle(word['English_sub_operation_name']),
      dataIndex: 'EnglishName',
      sorter: (a, b) => a.EnglishName.localeCompare(b.EnglishName),
      ...getColumnSearchProps('EnglishName'),
      ellipsis: true,
    },
    {
      title: TableTitle('Status'),
      dataIndex: 'Status',
      sorter: (a, b) => a.Status.localeCompare(b.Status),
      ...getColumnSearchProps('Status'),
      ellipsis: true,
      width: 140,
    },
  ]

  const eventAdd = (state, levelid, parent_id) => {
    setCheckChangeTable(checkChangeTable + 1)

    if (state == 'Company') {
      setVisible(true)
      setStateDrawer('add')
      setTitleDrawer(word['Add_Business'])
      setLevel(1)
      setLevel_ID(0)
    } else if (state == 'Operation') {
      setVisible2(true)
      setStateDrawer2('add')
      setTitleDrawer2(word['Add_Operation'])
      setLevel(2)
      setLevel_ID(levelid)
    } else {
      setVisible3(true)
      setStateDrawer3('add')
      setTitleDrawer3(word['Add_Sub_Operation'])
      setLevel(3)
      setLevel_ID(levelid)
      if (parent_id) {
        setParent_ID(parent_id)
      }
    }
  }
  const eventEdit = () => {
    if (level == 1) {
      setVisible(true)
      setStateDrawer('edit')
      setTitleDrawer(word['Edit_Business'])
    } else if (level == 2) {
      setVisible2(true)
      setStateDrawer2('edit')
      setTitleDrawer2(word['Edit_Operation'])
    } else {
      setVisible3(true)
      setStateDrawer3('edit')
      setTitleDrawer3(word['Edit_Sub_Operation'])
    }
  }

  const onClickRow = (e) => {
    eventEdit(e)
    setDataEditCompany(e.dataAll)
  }

  function onChangeTable(pagination2, filters, sorter, extra) {
    if (level === 1) {
      const currentSorter = Array.isArray(sorter) ? sorter[0] : sorter
      const nextOrderBy = tableFieldToApiField[currentSorter?.field] || ''
      const nextOrder =
        currentSorter?.order === 'ascend'
          ? 'asc'
          : currentSorter?.order === 'descend'
            ? 'desc'
            : ''

      setBusinessQuery((prevState) => ({
        ...prevState,
        page: pagination2.current,
        per_page: pagination2.pageSize,
        ...(extra?.action === 'sort'
          ? {
              order_by: nextOrderBy,
              order: nextOrder,
            }
          : {}),
      }))
      return
    }

    if (pagination != false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }

  const checkShowTable = (levelin) => {
    if (levelin == 1) {
      return (
        <Table
          key={checkChangeTable + 'Company'}
          onRow={(record) => {
            return {
              onClick: () => onClickRow(record), // click row
            }
          }}
          style={{ marginTop: 32 }}
          dataSource={dataSource}
          columns={columns}
          onChange={onChangeTable}
          pagination={pagination}
          showSorterTooltip={false}
        />
      )
    } else if (levelin == 2) {
      return (
        <div>
          <Table
            key={checkChangeTable + 'Operation'}
            onRow={(record) => {
              return {
                onClick: () => onClickRow(record), // click row
              }
            }}
            style={{ marginTop: 32 }}
            dataSource={dataSource2}
            columns={columns2}
            onChange={onChangeTable}
            pagination={pagination}
            showSorterTooltip={false}
          />
        </div>
      )
    } else {
      return (
        <Table
          key={checkChangeTable + 'SubOperation'}
          onRow={(record) => {
            return {
              onClick: () => onClickRow(record), // click row
            }
          }}
          style={{ marginTop: 32 }}
          dataSource={dataSource3}
          columns={columns3}
          onChange={onChangeTable}
          pagination={pagination}
          showSorterTooltip={false}
        />
      )
    }
  }

  const content = () => {
    if (dataCompany.length > 0) {
      let wordd = ''
      let textd = ''
      if (level == 1) {
        wordd = word['Company']
        textd = 'Business'
      } else if (level == 2) {
        wordd = word['Operation']
        textd = 'Operation'
      } else {
        wordd = word['Sub_Operation']
        textd = 'Project type'
      }
      return (
        <div>
          <div className="layout-button-add-normal-state">
            <h2 style={{ fontFamily: 'IBMPlexSansThaiBold' }}>{textd}</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={() => eventAdd(wordd, level_ID)}
                icon={<PlusOutlined className="Icon-color" />}
                className="BTN_Next"
                hidden={permissionPage.create ? false : true}
              >
                {word['Add']} {textd}
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </div>
          {checkShowTable(level)}
        </div>
      )
    } else {
      let worddd = ''
      let textd = ''
      if (level == 1) {
        worddd = word['Company']
        textd = 'Business'
      } else if (level == 2) {
        worddd = word['Operation']
        textd = 'Operation'
      } else {
        worddd = word['Sub_Operation']
        textd = 'Project type'
      }
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>
            {word['Please_add']} {textd} {word['in_your_project_optional']}
          </h2>
          <Button
            onClick={() => eventAdd(textd, level_ID)}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            {word['Add']} {textd}
          </Button>
        </EmptyContainer>
      )
    }
  }

  return (
    <CompanyContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left" style={{ marginBottom: 32 }}>
          <div style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}>
            <FilterSearchTree
              dataItems={companyOption}
              selectedItems={filteredCompanies}
              setSelectedItems={setFilteredCompanies}
              placeholderText={`Select Business`}
              itemTypeName="Business"
              treeId="filter-business"
              customTreeData={(item) => ({
                title: item.title,
                value: item.id,
                key: String(item.id),
              })}
              excludeAllID={true}
            />
          </div>

          <Tree
            treeCompany={filteredTreeCompany}
            openDefaultTree={openDefaultTree}
            setLevel_ID={setLevel_ID}
            setLevel={setLevel}
            eventAdd={eventAdd}
            setCheckByID={setCheckByID}
            setCompanyID={setCompanyID}
            setCheckChangeTable={setCheckChangeTable}
            checkChangeTable={checkChangeTable}
            setIdOptionOperation={setIdOptionOperation}
            setParent_ID={setParent_ID}
            resetBusinessQuery={() =>
              setBusinessQuery((prev) => ({ ...prev, page: 1, search_by: '', search: '' }))
            }
          />
        </div>
        <div className="layout-right">{content()}</div>
      </div>
      <DrawerCompany
        permissionPage={permissionPage}
        titleDrawer={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        visible={visible}
        stateDrawer={stateDrawer}
        infoUser={infoUser}
        setVisible={setVisible}
        getResultDataCompany={getResultDataCompany}
        dataEditCompany={dataEditCompany}
        getResultTreeCompany={getResultTreeCompany}
        checkByID={checkByID}
        getResultDataCompanyByID={getResultDataCompanyByID}
        setLevel_ID={setLevel_ID}
        getResultDataCompanyDelete={getResultDataCompanyDelete}
        setCheckChangeTable={setCheckChangeTable}
        checkChangeTable={checkChangeTable}
        setCheckRenderDelete={setCheckRenderDelete}
      />
      <DrawerOperation
        permissionPage={permissionPage}
        titleDrawer2={titleDrawer2}
        visible2={visible2}
        stateDrawer2={stateDrawer2}
        infoUser={infoUser}
        setVisible2={setVisible2}
        getResultDataCompany={getResultDataCompany}
        dataEditCompany={dataEditCompany}
        getResultTreeCompany={getResultTreeCompany}
        level_ID={level_ID}
        checkByID={checkByID}
        getResultDataCompanyByID={getResultDataCompanyByID}
        setCheckChangeTable={setCheckChangeTable}
        checkChangeTable={checkChangeTable}
        setCheckRenderDelete={setCheckRenderDelete}
      />

      <DrawerSubOperation
        permissionPage={permissionPage}
        titleDrawer2={titleDrawer3}
        visible2={visible3}
        stateDrawer2={stateDrawer3}
        infoUser={infoUser}
        setVisible2={setVisible3}
        getResultDataCompany={getResultDataCompany}
        dataEditCompany={dataEditCompany}
        getResultTreeCompany={getResultTreeCompany}
        level_ID={level_ID}
        checkByID={checkByID}
        getResultDataCompanyByID={getResultDataCompanyByID}
        setCheckChangeTable={setCheckChangeTable}
        checkChangeTable={checkChangeTable}
        setCheckRenderDelete={setCheckRenderDelete}
        parent_ID={parent_ID}
      />
    </CompanyContainer>
  )
}
export default Company
